import App from 'next/app'

import { ApolloProvider } from '@apollo/client'
import Cookies from 'js-cookie'
import '@fortawesome/fontawesome-svg-core/styles.css'

import withApolloClient from 'lib/WithApolloClient'
import initApollo from 'lib/InitApollo'
import { siteDomain, siteHost } from 'utils/CareguideDomains'
import { initSentry, captureException } from 'utils/Sentry'
import CareGuideCoreApplication from 'components/CareGuideCoreApplication'
import { getMiddleware, handleUrlTypoRedirect } from 'lib/middleware'
import { handleAutoLoginRedirect, handleUnauthorizedAccess } from 'lib/middleware/authenticate'
import { handleInvalidGetStartedStepRedirect } from 'lib/middleware/getstarted'
import { handleListingPageRedirects } from 'lib/middleware/listings'
import { handleDirectoryPageRedirects } from 'lib/middleware/directories'
import { handleBlogRedirects } from 'lib/middleware/blogs'

// @ts-ignore
class MyApp extends App<any> {
  static async getInitialProps(ctx?: TODO) {
    if (!process.browser) {
      initSentry()
    }
    const nextContext = ctx?.ctx
    const cookies = nextContext?.req?.headers?.cookie

    const initialProps = {
      domain: siteDomain(nextContext),
      host: siteHost(nextContext),
      cloudflareForwardedIp: nextContext?.req?.headers['cf-connecting-ip'],
      cookies,
    }
    const apolloClient = initApollo(initialProps)
    const middleware = getMiddleware([
      handleAutoLoginRedirect,
      handleUnauthorizedAccess,
      handleUrlTypoRedirect,
      handleInvalidGetStartedStepRedirect,
      handleListingPageRedirects,
      handleBlogRedirects,
      handleDirectoryPageRedirects,
    ])

    let pageProps = {
      ...initialProps,
      canonicalUrl: this.getCanonicalUrl(nextContext),
      isServerSideRedirect: false,
      errorCode: null,
    }

    const middlewareResult = await middleware({
      nextContext,
      apolloClient,
    })

    if (middlewareResult) {
      const { isServerSideRedirect, errorCode } = middlewareResult
      pageProps.isServerSideRedirect = isServerSideRedirect
      // @ts-ignore
      pageProps.errorCode = errorCode
    }

    return { pageProps }
  }

  static getCanonicalUrl(nextContext: TODO) {
    const host = siteHost(nextContext)
    if (nextContext.req && nextContext.req.url) {
      return `https://${host}${nextContext.req.url}`
    }

    return null
  }

  /**
   *
   * @description Catch and log capture client-side exceptions to Sentry
   * @param {*} error
   * @param {Object} errorInfo
   */
  async componentDidCatch(error: TODO, errorInfo: TODO) {
    captureException(error, { errorInfo })
    super.componentDidCatch(error, errorInfo)
  }

  render() {
    if (this.props.pageProps?.isServerSideRedirect) {
      return <></>
    }

    const Component = this.props?.Component
    const pageProps = this.props?.pageProps
    const apolloClient = this.props?.apolloClient
    const router = this.props?.router

    const stripeCoupon = router.query.coupon
    if (stripeCoupon) {
      Cookies.set('coupon', stripeCoupon)
    }

    return (
      <ApolloProvider client={apolloClient}>
        <CareGuideCoreApplication Component={Component} pageProps={pageProps} />
      </ApolloProvider>
    )
  }
}

export default withApolloClient(MyApp)
